/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import {
  deleteSalariesHistories,
  getSalariesHistoriesList,
  // getSalariesHistoriesSampleFiles,
  excelDownSalariesHistories,
} from "../../../apis/salary/salary-history";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import Profile from "../../../components/Profile";
import { getParams } from "../../../utils/params";
import { dateToFormat, getDay } from "../../../utils/date";
import SalaryHistory from "./SalaryHistory";
import { shallowEqual, useSelector } from "react-redux";
import { transformComma } from "../../../utils/validator/comma";
import PayStub from "../Component/PayStub";
import { downExcelFile } from "../../../utils/download";
import { toast } from "../../../utils/toast";
import systemAlert from "../../../utils/systemAlert";
import useForm from "../../../hooks/useForm";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";

import SalaryFileUpload from "./modal/SalaryFileUpload";
import EmployeeCodeFileUpload from "./modal/EmployeeCodeFileUpload";
import SalaryCopyAdd from "./modal/SalaryCopyAdd";


const SalaryDetail = (props) => {
  const history = useHistory();
  const { parts, employees, grades, permissions } = useSelector(
    (store) => ({
      parts: store.Data.parts,
      employees: store.Data.employees,
      grades: store.Data.grades,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );
  const [fields, setFields] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailList, setDetailList] = useState({});
  const [createOpen, setCreateOpen] = useState(false);
  const [targetPermission, setTargetPermission] = useState(null);
  const [resultRow, setResultRow] = useState({});

  const [mode, setMode] = useState("create");

  const [isEmployeeCodeModal, setIsEmployeeCodeModal] = useState(false);
  const [isSalaryModal, setIsSalaryModal] = useState(false);

  const [isCopyAddModal, setIsCopyAddModal] = useState(false);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'SALARY_HISTORY_MANAGEMENT');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "SALARY_HISTORY_MANAGEMENT");
      }
    }
  }, [permissions]);

  useEffect(() => {
    setFields([
      { title: "지급일", key: "payDate" },
      {
        title: "귀속월", key: "payFor", onValue: (v) => !isEmpty(v) && dateToFormat(v, "YYYY년 MM월")
      },
      {
        title: "부서",
        key: "employeeIdx",
        onValue: (value) => {
          //console.log("value: ", value)
          const employee = employees.find((employee) => employee.idx === value);
          if (!isEmpty(employee)) {
            return employee.partName;
          } else {
            return "";
          }
        },
      },
      {
        title: "직급",
        key: "employeeIdx",
        onValue: (value) => {
          //console.log("value: ", value)
          const employee = employees.find((employee) => employee.idx === value);
          if (!isEmpty(employee)) {
            return employee.gradeName;
          } else {
            return "";
          }
        },
      },
      {
        title: "이름",
        key: "employeeIdx",
        //type: 'profile'
        onValue: (value, field, data) => {
          return (
            data.employeeIdx > 0 ? (
              <Profile employeeIdx={data.employeeIdx} />
            ) : (<>-</>)
          );
        }
      },
      {
        title: "직원코드",
        key: "employeeCode",
      },
      {
        title: "지급합계",
        key: "totalAllowance",
        onValue: (value) => {
          return transformComma(value);
        },
      },
      {
        title: "공제합계",
        key: "totalDeduction",
        onValue: (value) => {
          return transformComma(value);
        },
      },
      {
        title: "차인지급액",
        key: "paymentByDifference",
        onValue: (value) => {
          return transformComma(value);
        },
      },
    ]);
  }, [parts, employees, grades]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: {},
      range: {
        payDate: [getDay(31), getDay(-31)]
      },

      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    if (targetPermission) {
      submit(form);
      setSubmit(submit);
    }
  }, [targetPermission]);

  const submit = ({ partIdx, employeeIdx, ...form }) => {
    if (!isEmpty(employeeIdx)) {
      form.search.employeeIdx = employeeIdx[0].idx;
    } else {
      form.search.employeeIdx = "";
    }

    if (!isEmpty(partIdx)) {
      form.search.partIdx = Number(partIdx);
    } else {
      form.search.partIdx = "";
    }
    form.order = [
      {
        "payDate": "desc"
      },
      {
        "idx": "asc"
      },
    ];
    setIsLoading(true);
    setSelectedList([]);
    setList([]);
    setTotal(0);
    getSalariesHistoriesList(getParams(form))
      .then((res) => {
        setIsLoading(false);
        setList(res.data.salaryHistories);
        setTotal(res.data.total);
        const sum = res.data.sum;
        if (!isEmpty(sum)) {
          setResultRow({
            payDate: '합계',
            totalAllowance: sum[0].sumTotalAllowance,
            totalDeduction: sum[0].sumTotalDeduction,
            paymentByDifference: sum[0].sumPaymentByDifference,
          });
        }
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const headerButtons = [
    {
      isHide: targetPermission && targetPermission.level <= 1,
      label: "급여내역 만들기",
      action: () => {
        setMode("create");
        setCreateOpen(true);
      },
    },
  ];

  const filters = [
    {
      title: "지급일",
      key: 'range.payDate',
      type: "customdatepicker",
    },
    {
      title: "부서",
      type: "select",
      key: "partIdx",
      options: {
        list: [
          { label: "전체", value: "" },
          ...parts.map((part) => ({ label: part.partName, value: part.idx })),
        ],
      },
    },
    {
      title: "직원선택",
      type: "searchEmployee",
      key: "employeeIdx",
      isSingle: true,
    },
  ];

  const selectedDelete = async () => {

    setIsLoading(true);
    try {

      for (const data of selectedList) {
        await deleteSalariesHistories(data.idx);
      }
    } catch (error) {
      systemAlert('삭제 할 수 없는 내용이 있습니다.');
    }

    setIsLoading(false);
    submit(form);
  };

  const tableButtons = [
    // {
    //   label: (
    //     <>
    //       송금지원 엑셀 <i className="mdi mdi-arrow-collapse-down" />
    //     </>
    //   ),
    //   color: "gray-line",
    //   action: () => {
    //     systemAlert("계좌정보 등록된 직원이 없습니다.");
    //   },
    //   disabled: isEmpty(selectedList),
    // },


    {
      label: "일괄삭제",
      disabled: isEmpty(selectedList),
      color: "gray-line",
      action: () => {

        systemAlert('선택된 급여 내역을 삭제 하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                selectedDelete();
              }
            }
          ]
        });
      }
    },
    {
      isHide: targetPermission && targetPermission.level <= 1,
      label: "급여 엑셀 업로드",
      color: "gray-line",
      action: (e) => {
        e.preventDefault();
        setIsSalaryModal(true);
      }
    },
    {
      label: (
        <>
          엑셀 다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      action: () => {
        const { search, range } = form;
        const body = { search, range, limit: 9999 };

        excelDownSalariesHistories(getParams(body))
          .then((res) => {
            downExcelFile(res, "급여내역.xlsx");
          })
          .catch((err) => {
            toast.error("엑셀 다운로드에 실패하였습니다.");
          });
      },
    },
    {
      label: "복사하기",
      disabled: isEmpty(selectedList),
      action: () => {
        setIsCopyAddModal(true);
      }
    },
  ];

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert('해당 급여 내역을 삭제 하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  setIsLoading(true);
                  deleteSalariesHistories(data.idx)
                    .then(() => {
                      setIsLoading(false);
                      submit(form);
                    })
                    .catch((err) => { });
                }
              }
            ]
          });
        },
      },
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setDetailList(data);
          setMode("edit");
          setCreateOpen(true);
        },
      },
    ],
  };

  const onRowClick = (data, e) => {
    if (e.target.tagName !== "TD") return;
    setDetailOpen(true);
    setDetailList(data);
  };

  return (
    !isEmpty(targetPermission) && (
      <>
        <div className="print-out">
          <PageHeader title={targetPermission.name} buttons={headerButtons} />
          <Filters
            isLoading={isLoading}
            filters={filters}
            submit={filterSubmit}
            form={form}
            onChange={handleOnChange}
          />
          <ControlTable
            isLoading={isLoading}
            fields={fields}
            list={list}
            isControl
            selectedList={selectedList}
            setSelected={setSelectedList}
            buttons={tableButtons}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            total={total}
            rowBtn={rowBtnConfig}
            onSelect={onRowClick}
            submit={handleSubmit}
            resultRow={resultRow}
          />
        </div>
        <SalaryHistory
          open={createOpen}
          setOpen={setCreateOpen}
          submit={submit}
          params={form}
          mode={mode}
          list={detailList}
          setList={setDetailList}
        />
        <PayStub
          open={detailOpen}
          setOpen={setDetailOpen}
          list={detailList}
          setList={setDetailList}
        />
        <SalaryFileUpload
          open={isSalaryModal}
          setOpen={setIsSalaryModal}
          setIsLoading={setIsLoading}
          filterSubmit={filterSubmit}
          setIsEmployeeCodeModal={setIsEmployeeCodeModal}
        />
        <EmployeeCodeFileUpload
          open={isEmployeeCodeModal}
          setOpen={setIsEmployeeCodeModal}
          setIsLoading={setIsLoading}
          filterSubmit={filterSubmit}
        />

        <SalaryCopyAdd
          open={isCopyAddModal}
          setOpen={setIsCopyAddModal}
          setIsLoading={setIsLoading}
          selectedList={selectedList}
          setSelectedList={setSelectedList}
          submit={filterSubmit}
        />
      </>
    ));
};

export default SalaryDetail;

